import e from "@dialpad/dialtone-tokens/layered/themes/tokens-lavender-colors.css?inline";
//#region themes/lavender.js
var t = {
	brand: {
		css: e,
		name: "lavender"
	},
	material: { name: "graphite" }
};
//#endregion
export { t as default };
